import { useEffect, useState } from 'react';
import { getMenu } from '../services/menu';

const useMenu = () => {
	const [menu, setMenu] = useState([]);
	const [error, setError] = useState("");
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const fetchMenu = async () => {
			const menuFromStorage = JSON.parse(localStorage.getItem('menu'));
			if (menuFromStorage === null || (new Date().getTime() - menuFromStorage.timestamp > 3600000)) {
				try {
					const response = await getMenu();
					if (response.status === 200) {
						localStorage.setItem('menu', JSON.stringify({ timestamp: new Date().getTime(), menu: response.data }));
						setMenu(response.data);
					} if (response.status === 400) {
						setMenu(response.data);
					}
				} catch (error) {
					setError(error);
				} finally {
					setIsLoading(false);
				}
			} else {
				setMenu(menuFromStorage.menu);
				setIsLoading(false);
				setError("");
			}
		}
		fetchMenu();
	}, []);
	return {
		serviceMenu: menu,
		error,
		isLoading,
	};
};

export default useMenu;